import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardTitle, CardSection } from 'components/Card';
import Message from 'components/Message';
import Button from 'components/Button';
import { bem } from 'helpers/class-name';
import messages from '../Campaigns.messages';
import './Modals.scss';

const { block, element } = bem('campaigns-modal');

const CampaignEndModal = props => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { onModalConfirm, onClose } = props;

  function handleOnConfirm() {
    setIsSubmitting(true);
    onModalConfirm();
  }

  return (
    <Card className={block()} flush>
      <CardSection>
        <Message as={CardTitle} className={element('card-title')} message={messages.modals.endNowTitle} />
        <Message as="p" message={messages.modals.endNowDescription} />
        <Message as="p" message={messages.modals.endNowDisclaimer} />
      </CardSection>
      <div className={element('buttons')}>
        <Message
          as={Button}
          className="mr-s"
          styled="tertiary"
          message={messages.form.btnCancel}
          onClick={onClose}
          disabled={isSubmitting}
        />
        <Message
          as={Button}
          styled="danger-solid"
          message={messages.form.btnEndCampaign}
          onClick={handleOnConfirm}
          waiting={isSubmitting}
        />
      </div>
    </Card>
  );
};

CampaignEndModal.propTypes = {
  onModalConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

CampaignEndModal.modalConfig = {
  shouldCloseOnOverlayClick: false,
};

export default CampaignEndModal;
